// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"153":"151d95b3","453":"d4722a7d","736":"2d82a141","900":"7b05c6cd","983":"c0a5fd14"}[chunkId] + ".chunk.js";
};